import Model from "../../../../Model.js";

/**
 * Represents where data for a period column template is coming from.
 * Examples include actual accounting data, budget and forecast.
 */
export default class AbstractPeriodColumnTemplateSource extends Model {
	isActualsSource() {
		return false;
	}

	isBudgetSource() {
		return false;
	}

	isForecastEstimateSource() {
		return false;
	}

	isForecastSource() {
		return false;
	}

	isForecastEstimateColumn() {
		return false;
	}

	instantiate(...args) {
		const constructor = this._instanceClass();

		return new constructor(this._interpretationSpec(...args));
	}

	_instanceClass() {
		return this._subclassResponsibility();
	}

	_interpretationSpec() {
		return {};
	}

	_serializedProperties() {
		const properties = super._serializedProperties();

		properties.isBudgetColumn = this.isBudgetSource();
		properties.isForecastEstimateColumn = this.isForecastEstimateColumn();

		return properties;
	}
}
